"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Themes = void 0;
const apps_1 = require("../apps");
class Themes {
    static ThemeTypes;
}
exports.Themes = Themes;
(function (Themes) {
    let availableThemes;
    (function (availableThemes) {
        availableThemes["theme1"] = "theme1";
        availableThemes["theme2"] = "theme2";
        availableThemes["theme3"] = "theme3";
        availableThemes["theme4"] = "theme4";
        availableThemes["theme5"] = "theme5";
        availableThemes["theme6"] = "theme6";
    })(availableThemes = Themes.availableThemes || (Themes.availableThemes = {}));
    Themes.DefaultThemes = {
        [apps_1.Apps.titles.crossmark]: availableThemes.theme1,
        [apps_1.Apps.titles.embark]: availableThemes.theme6,
    };
    Themes.CrossmarkThemeKey = {
        [availableThemes.theme1]: 'light',
        [availableThemes.theme2]: 'dark',
        [availableThemes.theme3]: 'moon',
        [availableThemes.theme4]: 'sun',
        [availableThemes.theme5]: 'blueberry',
        [availableThemes.theme6]: 'treeberry',
    };
    Themes.EmbarkThemeKey = {
        [availableThemes.theme1]: '',
        [availableThemes.theme2]: '',
        [availableThemes.theme3]: '',
        [availableThemes.theme4]: '',
        [availableThemes.theme5]: '',
        [availableThemes.theme6]: 'treeberry',
    };
    Themes.ThemeKey = {
        [apps_1.Apps.titles.crossmark]: Themes.CrossmarkThemeKey,
        [apps_1.Apps.titles.embark]: Themes.EmbarkThemeKey,
    };
    Themes.ToastColor = {
        [availableThemes.theme1]: 'light',
        [availableThemes.theme2]: 'dark',
        [availableThemes.theme3]: 'light',
        [availableThemes.theme4]: 'light',
        [availableThemes.theme5]: 'dark',
        [availableThemes.theme6]: 'dark',
    };
    Themes.SpinnerColor = {
        [availableThemes.theme1]: 'black',
        [availableThemes.theme2]: 'white',
        [availableThemes.theme3]: 'black',
        [availableThemes.theme4]: 'black',
        [availableThemes.theme5]: 'light',
        [availableThemes.theme6]: 'light',
    };
})(Themes || (exports.Themes = Themes = {}));
//# sourceMappingURL=index.js.map